import { Text } from '@cubeyou-team/hx-react-components';
import React, { FC, MouseEvent } from 'react';
import styled from 'styled-components';

import { DestinationImage } from '../../DestinationImage';

interface DestinationCardProps {
  image: string;
  title: string;
  isSelected: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
}

const StyledDestinationCard = styled.button`
  padding: 1rem 0.5rem;
  width: 105px;
  height: 103px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 0.25rem;
  border: 1px solid #d8d7ea;

  background-color: #fff;

  &:hover {
    border: 0.125rem solid #1779cc;
    cursor: pointer;
  }

  .image {
    width: 2.5rem;
    height: 2.75rem;
  }

  .title {
    display: flex;
    align-items: center;
    height: 2.8em;
    line-height: 0.75rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const DestinationCard: FC<DestinationCardProps> = ({
  image: icon,
  title = 'Not Available',
  onClick,
}) => {
  return (
    <StyledDestinationCard onClick={onClick}>
      <DestinationImage src={icon} alt={title} />
      <Text size="xsmall" align="center" className="title">
        {title}
      </Text>
    </StyledDestinationCard>
  );
};
